export default __webpack_public_path__ + "static/media/slider-midios-3.4e735908.png";